import { Space } from '@sravni/react-design-system/lib/Space';

import { EBS_DEFAULT_CONTENT } from '../../EbsDialogBanner.config';
import styles from '../../EbsDialogBanner.module.scss';
import { EbsInformer } from '../EbsInformer/EbsInformer';

export function EbsBannerDefaultGuide({ isMobile }: { isMobile: boolean }) {
  return (
    <Space size={0} direction="column">
      <Space direction="column" size={8} className={styles.gridContainer}>
        {EBS_DEFAULT_CONTENT(isMobile).map((info, step) => (
          // eslint-disable-next-line react/no-array-index-key
          <EbsInformer key={`step-id-${step}`} step={step + 1} {...info} />
        ))}
      </Space>
    </Space>
  );
}
